import React, { useEffect, useState, useMemo } from 'react'
import { Wrapper, BarStrip,  StepperItem, ProgressBar, Modal, TextAreaIcon, TextFieldIcon, FileFieldIcon } from '../_components'
import Table, { SelectColumnFilter } from '../_components/Table'
import data from '../fixtures'
import { Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { setDisplayVerify } from '../_slices/AppSlice' 
import Axios from 'axios'
import moment from 'moment'
import { FaAddressCard } from 'react-icons/fa'

const steps = [
  "Pending",
  "Actioned"
]

const ActionField = ( record ) => {
    return (
      <div onClick={async () => {
        await localStorage.setItem( "link", "display" )
        await localStorage.setItem( "applicationId", record.value )
        return window.location.reload()
      } } className="cursor-pointer w-auto md:w-20 lg:w-24 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
        {`View`}
      </div>
    )
}


const StatusField = record => {
  let classes = ""
  switch( record.value?.toLowerCase() ) {
    case "pending":
      classes = "bg-red-500 text-white"
      break
    case "completed":
      classes = "bg-orange-500 text-black"
      break
    default:
      break;
  }

  return (
    <div className={`${ classes } text-xs text-center px-2 py-1 rounded`}>
      {record.value}
    </div>
  )
}

const VerifyField = record => {
  // const dispatch = useDispatch()

  const handleClick = async id => {
    await localStorage.setItem( "applicationId", id )
    await localStorage.setItem( "link", "display")
    window.location.reload()
  }

  return (
    record.row.original.verify_status?.toLowerCase() !== "completed" && 
    (<div onClick={() => handleClick( record.value )} className="uppercase cursor-pointer bg-green-700 text-xs text-center px-2 py-1 rounded text-white">
      {`Verify Documents`}
    </div> )
  )
}

export default function AllDocumentVerify( { product } ) {

  const ApplicationColumns = useMemo( () => [
    {
      Header: "Actions",
      accessor: "id",
      Cell: VerifyField
    },
    {
      Header: "#",
      accessor: "recordId"
    },
    {
      Header: "S.No",
      accessor: "sno"
    },
    {
      Header: "Registered Name of ITSP",
      accessor: "applicant"
    },
    {
      Header: "Date Applied",
      accessor: "date"
    },
    {
        Header: "Date Updated",
        accessor: "date_updated"
    },
    {
        Header: "Contact Person",
        accessor: "contact_person"
    },
    {
      Header: "Mobile No",
      accessor: "phone_number"
    },
    {
      Header: "Verify Status",
      accessor: "verify_status",
      Cell: StatusField
    },
    {
        Header: "Verification Report",
        accessor: "report"
    },
  ] )


  const ActionedColumns = useMemo( () => [
    // {
    //   Header: "Actions",
    //   accessor: "id",
    //   Cell: VerifyField
    // },
    {
      Header: "#",
      accessor: "recordId"
    },
    {
      Header: "S.No",
      accessor: "sno"
    },
    {
      Header: "Registered Name of ITSP",
      accessor: "applicant"
    },
    {
      Header: "Date Applied",
      accessor: "date"
    },
    {
      Header: "Date Updated",
      accessor: "date_updated"
    },
    {
      Header: "Contact Person",
      accessor: "contact_person"
    },
    {
      Header: "Mobile No",
      accessor: "phone_number"
    },
    {
      Header: "Verify Status",
      accessor: "verify_status",
      Cell: StatusField
    },
    {
        Header: "Verification Report",
        accessor: "report"
    },
  ] )

  const dispatch = useDispatch()
  const [ records, setRecords ] = useState( [] )
  const [ loading, setLoading ] = useState( true )
  const [ showModal, setShowModal ] = useState( false )
  const [ tag, setTag ] = useState( "Pending" )
  const state = useSelector( state => {
    return {
      id: state.application.verifyModal?.id,
      displayModal: state.application.verifyModal?.display,
      record: state.application.verifyModal?.record,
    }
  } )

  useEffect( () => {
    if( loading ) {
        fetchApplications()
    }
  },[ loading ])

  const handleResults = ( values ) => {
    switch( localStorage.getItem( "role" )?.toUpperCase() ){
      case "VERIFIER":
        return values.filter( item => {
          if( tag?.toLowerCase() === "pending" ) {
            return parseInt( item.stage ) === 1
          }
          if( tag?.toLowerCase() === "actioned" ) {
            return parseInt( item.stage ) > 1
          }
        } )
      case "AUDITOR":
        return values.filter( item => parseInt( item.stage ) === 3  )
      case "QA":
        return values.filter( item => parseInt( item.stage ) === 4  )
      case "APPROVER":
        return values.filter( item => parseInt( item.stage ) === 5  )
      default:
        return
    }
  }

  const fetchApplications = async () => {
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication` ) 
      if( response.data ) {
       const results = response.data.map( ( result, index ) => {
        return {
            recordId: `${index+1}`,
            progress: result.progress,
            applicant: result.trading_name,
            date: moment( result.created_at ).format( "DD MMM, YYYY" ), 
            date_updated: moment( result.updated_at ).format( "DD MMM, YYYY" ),
            contact_person: `${result.contact_first_name || ""} ${result.contact_last_name || ""}`,
            designation: result.designation,
            email_id: result.created_by,
            phone_number: result.contact_phone_number,
            verify_status: result.verification_status || "Pending",
            updated_at: result.updated_at,
            id: result.id,
            report: "",
            stage: result.stage,
            progress: result.progress
        }
       } ).sort( ( a, b ) => {
        return moment( b.updated_at ).format( "YYYYMMDDHHMM" ) - moment( a.updated_at ).format( "YYYYMMDDHHMM" )
       } )
       //handle results
      //  let items = handleResults( results )
       //update the status
       setRecords( results )
       setLoading( false )
      }
    } catch (error) {
      alert( "Server error occured." )
      setLoading( false )
    }
  }

  const handleVerification = async () => {
    // try {
    //   const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/itcoverify`, {
    //     id: state.id,
    //     progress: parseInt( state.record.progress + 20 ),
    //     email_address: state.record.created_by,
    //     task: "Verified",
    //     created_by: localStorage.getItem( "email" ),
    //     comment: "This application is now verified",
    //     verification_status: "Completed"
    //   } )
    //   if( response.data ) {
    //     alert( response.data.message )
    //     await dispatch( setDisplayVerify( { 
    //       flag: false
    //     } ))
    //     return window.location.reload()
    //   }
    // } catch (error) {}
  }

  return (
    <Wrapper>
        <div className="flex flex-col h-full">
          <BarStrip />
          <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
            <div className="px-5 py-2 text-sm bg-white">
              {`Document Verification Details of IT Service Providers`}
            </div>

            <div className="flex flex-col items-start justify-center w-full bg-white">
              <div className="flex flex-row border-b border-gray-500 rounded-sm">
                {/* tabs */}
                {steps.map( ( item, index ) => {
                  return (
                  <StepperItem 
                    edge={index === 0} 
                    active={tag.toUpperCase() === item?.toUpperCase()} 
                    key={item} 
                    label={item} 
                    onPress={() => {
                      return setTag( item )
                    } } />
                  )
                } )}
              </div>
              <Table 
                label="Application Details"
                columns={tag === "Pending" ? ApplicationColumns : ActionedColumns}
                data={handleResults( records )}
                hidePagination={false}
              />
            </div>

          </div>
        </div>


        {/* records.filter( val => {
                  return tag === "Pending" ? parseInt( val.stage ) === 1 : parseInt( val.stage ) > 1
                } ) */}

        {/* <Modal
          title={"Document Verification"}
          displayModal={state.displayModal} 
          handleDisplayModal={() => dispatch( setDisplayVerify( { flag: false, id: null } ) ) }
          handleFormSubmit={() => {}}>
            <div className="grid grid-cols-1">
              <Formik initialValues={{}} onSubmit={() =>{}}>
                { ( { handleBlur, handleChange, values } ) => {
                  return (
                    <form>
                    <table className="w-full border">
                      <thead className="text-xs bg-gray-200 font-bold">
                          <th>Document</th>
                          <th>Year of Completion</th>
                          <th>Issuing Institution</th>
                          <th>Grade( where applicable )</th>
                      </thead>
                     <tbody>
                    {[
                        { id: 1, label: "Certificate", slug: "cert_1" },
                        { id: 2, label: "Ordinary Diploma", slug: "diploma_1" },
                        { id: 3, label: `Bachelor's Degree`, slug: "bachelor_1" }
                    ].map ( ( { id, label, slug }, index ) => {
                        return (
                        <tr key={id} className="text-xs border border-gray-300">
                            <td className="text-center py-2">{label}</td>
                            <td className="text-center py-2">
                                <TextFieldIcon 
                                    type="number"
                                    name={`${slug}_year`}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    value={values[`${slug}_year`]}
                                    iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                    label="Year"
                                    required={false}
                                    />
                            </td>
                            <td className="text-center py-2">
                                <TextFieldIcon 
                                    type="text"
                                    name={`${slug}_institution`}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    value={values[`${slug}_institution`]}
                                    iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                    label="Institution"
                                    required={false}
                                    />
                            </td>
                            <td className="text-center py-2">
                                <TextFieldIcon 
                                    type="number"
                                    name={`${slug}_grade`}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    value={values[`${slug}_grade`]}
                                    iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                    label="Grade"
                                    required={false}
                                    />
                                
                            </td>
                        </tr>
                        )
                    } )}
                </tbody>
                      </table>
                    </form>
                  )
                } }
              </Formik>
            </div>
          
          <div className="flex items-center justify-center my-2">
            <button className="bg-green-500 text-base text-center text-white px-2 py-1" onClick={() => handleVerification()}>Verify</button>
          </div>
        </Modal> */}
    </Wrapper>
  )
}

{/* <div className="grid grid-cols-6 gap-1">
            <div className="border">
              <h2 className="text-xs font-bold bg-green-100">
                {`Parameter`}
              </h2>
              <div className="text-xs">
                {`Registered name of IT Service Provider`}
              </div>
            </div>
            <div>
              <h2 className="text-xs font-bold bg-green-100">{`Applicant Information`}</h2>
              <div className="text-xs">{`Registered name of IT Service Provider`}</div>
            </div>
            <div>
              <h2 className="text-xs font-bold bg-green-100">{`Attachment`}</h2>
              <div className="text-xs">{`Registered name of IT Service Provider`}</div>
            </div>
            <div>
              <h2 className="text-xs font-bold bg-green-100">{`Document Status`}</h2>
              <div className="text-xs">{`Registered name of IT Service Provider`}</div>
            </div>
            <div>
              <h2 className="text-xs font-bold bg-green-100">{`Verify`}</h2>
              <div className="text-xs">{`Registered name of IT Service Provider`}</div>
            </div>
            <div>
              <h2 className="text-xs font-bold bg-green-100">{`Reasons`}</h2>
              <div className="text-xs"></div>
            </div>
          </div> */}
